import { createApp } from 'vue'
import CourseOverview from '../components/CourseOverview.vue'

export function mountCourseOverview() {
  const el = document.getElementById('course-overview-app')
  if (!el) return

  const app = createApp(CourseOverview, {
    unitsUrl: el.dataset.unitsUrl,
    signOutUrl: el.dataset.signOutUrl,
    userEmail: el.dataset.userEmail,
    billingUrl: el.dataset.billingUrl,
    subscribed: el.dataset.subscribed === 'true',
    dialect: el.dataset.dialect || 'south',
  })
  app.mount(el)
}
